import cx from 'classnames';
import is from 'is_js';
import assets from 'modules/assets';
import * as intf from 'modules/interface';
import apiClient from 'modules/megatron/apiClient';
import store from 'modules/megatron/store';
import { setup as mpSetup } from 'modules/megatron/weixin';
import navigator from 'modules/navigator';
import { Component } from 'react';

is.setRegexp(/^1(3|4|5|6|7|8)\d{9}$/, 'nanpPhone');

export interface Config {
  navigationBarTitleText?: string;
}

/**
 * Base Component，为所有业务组件封装通用功能
 *
 * @export
 * @class Base
 * @extends {Component}
 */
export default class Base<P = {}, S = {}> extends Component<P, S> {
  /**
   * 页面信息配置
   */
  public config: Config = {};

  /**
   * check lib
   *
   * @protected
   * @memberof Base
   */
  protected readonly is = is;

  /**
   * classnames
   *
   * @protected
   * @memberof Base
   */
  protected readonly cx = cx;

  /**
   * 静态资源
   *
   * @protected
   * @memberof Base
   */
  protected readonly assets = assets;

  /**
   * 导航
   *
   * @protected
   * @memberof Base
   */
  protected readonly navigator = navigator;

  /**
   * api
   *
   * @protected
   * @memberof Base
   */
  protected readonly apiClient = apiClient;

  /**
   * 接口方法
   *
   * @protected
   * @memberof Base
   */
  protected readonly interface = intf;

  public async componentDidMount() {
    mpSetup();
    await store.user.init();

    this.useTitle();
    this.didMount();
  }

  /**
   * componentDidMount
   */
  public didMount() {}

  /**
   * componentDidShow
   */
  public didShow() {}

  /**
   * componentDidHide
   */
  public didHide() {}

  /**
   * componentWillUnmount
   */
  public willUnmount() {}

  private useTitle = () => {
    document.title = this.config.navigationBarTitleText || '';
  }
}
